/**
 * Files from a paste or drop event that match an `accept` list like `image/*,application/pdf`.
 * Screenshots have no useful name ("image.png"), so pasted images get `<name> <n>.<ext>`.
 */
export const matchesAccept = (file: { type: string }, accept: string): boolean =>
  !accept ||
  accept.split(',').some((item) => {
    const accepted = item.trim();
    return accepted.endsWith('/*') ? file.type.startsWith(accepted.slice(0, -1)) : file.type === accepted;
  });

export const getTransferFiles = (transfer: DataTransfer | null, accept: string): File[] =>
  Array.from(transfer?.files || []).filter((file) => matchesAccept(file, accept));

export const renamePastedImage = (file: File, name: string): File => {
  // "image/svg+xml" → svg, "image/jpeg" → jpg.
  const subtype = file.type.split('/')[1]?.split('+')[0];
  const extension = subtype === 'jpeg' ? 'jpg' : subtype || 'png';
  return new File([file], `${name}.${extension}`, { type: file.type, lastModified: file.lastModified });
};

/** True when the paste happened in a field where text is typed, so it must not be taken as a file. */
export const isTextFieldTarget = (target: EventTarget | null): boolean =>
  target instanceof HTMLElement &&
  (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target.isContentEditable);
